export const OPEN_REACT_QUERY_DEVTOOLS_EVENT = "breaze:open-react-query-devtools";
